<template>
  <div>
    <article class="media">
      <div class="media-content">
        <div class="content">

          <div class="columns">

            <div class="column">
              <b-field label="Mes">
                <b-select expanded v-model="month" placeholder="Selecciona un mes">
                  <option
                    v-for="mes in monthsList"
                    :value="mes.id"
                    :key="mes.id">
                    {{ mes.name }}
                  </option>
                </b-select>

              </b-field>
            </div>

            <div class="column">
              <b-field label="Año">

                <b-select expanded v-model="year" placeholder="Selecciona un año">
                  <option
                    v-for="anio in yearsList"
                    :value="anio"
                    :key="anio">
                    {{ anio }}
                  </option>
                </b-select>
              </b-field>
            </div>

          </div>

          <div class="center">
            <button :disabled="!validateFilters" @click="goSearchReport" class="button is-info is-rounded ">Consultar</button>
          </div>

          <div class="btn-export report" v-show="listBoxes.length>0">
            <div>
              <button  @click="downloadReportPdf" class="button  is-small">
                <b-icon icon="file-pdf" class="colour-pdf"></b-icon> <span style="font-weight:bold"> Descargar PDF </span>
              </button>

              <button  @click="downloadReportExcel" class="button  is-small">
                <b-icon icon="file-excel" class="colour-excel"></b-icon> <span style="font-weight:bold"> Descargar Excel </span>
              </button>
            </div>
          </div>

          <!-- <b-dropdown class="is-fullwidth" :disabled="!listBoxes.length>0">
            <button class="button is-info is-rounded" slot="trigger">
              <span>Exportar</span>
              <b-icon icon="menu-down"></b-icon>
            </button>

            <b-dropdown-item @click="doExportReportFilesPdf('pdf')">a pdf</b-dropdown-item>
            <b-dropdown-item @click="doExportReportFilesPdf('xlsx')">a excel</b-dropdown-item>
         </b-dropdown> -->

        </div>

        <div class="report">

          <b-table
            :data="listBoxes"
            :hoverable="true"
            :mobile-cards="true"
          >

            <template  slot-scope="props">

              <b-table-column  label="Cliente" centered  class="is-size-7">
                {{ props.row.cliente }}
              </b-table-column>

              <b-table-column  label="Año"  centered  class="is-size-7">
                {{ props.row.anio }}
              </b-table-column>

              <b-table-column  label="Mes"  centered  class="is-size-7">
                {{ props.row.mes }}
              </b-table-column>

               <b-table-column  label="Area"  centered  class="is-size-7">
                {{ props.row.area }}
              </b-table-column>

              <b-table-column  label="Cajas" centered   class="is-size-7">
                {{ props.row.totalBox }}
              </b-table-column>

            </template>


            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon
                      icon="emoticon-sad"
                      size="is-large">
                    </b-icon>
                  </p>
                  <p>Sin resultados.</p>
                </div>
              </section>
            </template>


          </b-table>


        </div>


      </div>
    </article>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Util from '../../../util'
import BoxesByMonthApi from '../../../api/modules/BoxesByMonthApi'

export default {
  name: "box-by-area-registration-date",
  data(){
      //calculo Anios
      var yearCtrl=2017
      const limit = new Date().getFullYear() - yearCtrl
      const arrayYears= [yearCtrl]
      for (var i = 0; i < limit; i++) {
        yearCtrl++
        arrayYears.push(yearCtrl)
      }

      return {
        //filters
        monthsList:[{id:1,name:'Enero'},
          {id:2,name:'Febrero'},
          {id:3,name:'Marzo'},
          {id:4,name:'Abril'},
          {id:5,name:'Mayo'},
          {id:6,name:'Junio'},
          {id:7,name:'Julio'},
          {id:8,name:'Agosto'},
          {id:9,name:'Septiembre'},
          {id:10,name:'Octubre'},
          {id:11,name:'Noviembre'},
          {id:12,name:'Diciembre'},],
        yearsList:arrayYears,
        year:null,
        month:null,
        clientSelected:null,

        searchOptions: {perPage: 10, pageNumber: 1,sortField:'name',sortOrder:'asc'},
        defaultSortOrder: 'asc',
        //data
        fileList:[],
        total: 0,
        boxes:0,
        listBoxes: []


      }
    },
    methods:{
      classStatusFile(status) {
        return status=='stock'?'is-success':status=='req'?'is-warning':status=='trans'?'is-info':status=='out'?'is-black':status=='pickup'?'is-info':status=='transpickup'?'is-info':'is-danger'
      },

      onPageChange(page) {
        this.searchOptions.pageNumber = page
        this.searchReport().then()
      },

      doExportReportFilesPdf(type){
         const params = [
            `month=${this.month}`,
            `year=${this.year}`,
            `export=${true}`,
            `type=${type}`,
          ].join('&')

          // BoxesByMonthApi.loadReportBoxesAreaByMonth(this,{params,idClient:Util.getClient().id,type: type}).then();
      },
      goSearchReport(){

          const params = [
            `month=${this.month}`,
            `year=${this.year}`,
          ].join('&')

          BoxesByMonthApi.loadReportBoxesAreaByMonth(this,{params,idClient:Util.getClient().id}).then(data=>{
            console.log("data:",data);
             this.listBoxes=data
          }).catch(error=>{
            this.listBoxes=[]
            })
      },

       downloadReportPdf(){
        const params = [
            `month=${this.month}`,
            `year=${this.year}`
          ]
          .join('&');

        BoxesByMonthApi.loadReportBoxesAreaByMonthPDF(this,{params,idClient:Util.getClient().id}).then()
      },

      downloadReportExcel() {
        const params = [
            `month=${this.month}`,
            `year=${this.year}`
          ]
          .join('&');

        BoxesByMonthApi.loadReportBoxesAreaByMonthEXCEL(this,{params,idClient:Util.getClient().id}).then()
      },
    },

    computed: {
      validateFilters(){
        return (this.month !=null && this.year!=null)
      },
    },

    created(){

      this.month=new Date().getMonth()
      this.year=new Date().getFullYear()

    }
}
</script>
<style scope>
.center {
  text-align: center;
}
.colour-pdf {
  color:red;
}
.colour-excel {
  color:green;
}
.btn-export {
  text-align: right;
  margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/reportes/files/BoxesByMonthByArea.vue